import React, {useState} from 'react';
import {CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@mui/material";
import {Col, Row} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {bbDangerousDateToBBApiDate, bbFormattedDateString} from "../../../util/bbHelpers";
import CloseIcon from "@material-ui/icons/Close";
import {Button} from "@material-ui/core";
import {updateEntitySettings} from "../../../actions";


const UpdateEntityCycleDatesDialog = ({ entityId=null, children = null, dateToEdit=null,})=>{

    const {entitiesList, loadingUpdateEntityCycleDate, loadingUpdateEntityCycleDateError,  } = useSelector(({admin})=>admin);

    const [ dialogOpen, setDialogOpen] = useState(false);
    const [ menuOpen, setMenuOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');

    const entityToUse = entitiesList
        && entityId
        && entitiesList.find((x)=> x.id === entityId)
    ? entitiesList.find((x)=> x.id === entityId)
        : null;

    const entitySettings = entityToUse
    && entityToUse.settings
    ? entityToUse.settings
        : null;

    const dispatch = useDispatch();

console.log("selected date equals", selectedDate, new Date(Date.now()))

    const handleSubmit = () =>{
        console.log("This is the value that will be passed to the api call", selectedDate)
        dispatch(updateEntitySettings(entityId, dateToEdit, selectedDate))
        setDialogOpen(false)
    }

    return(
        <span className={"d-inline"}>
           <span onClick={()=>setDialogOpen(true)}
               className={"m-0 p-0 d-inline"}>{children}</span >

            {dialogOpen &&
                <Dialog open={dialogOpen}
                        fullWidth={true}
                        fullScreen={false}
                        maxWidth={"sm"}
                        className={"m-1 p-1 animated fadeIn animation-duration-6"}
                        aria-labelledby="form-dialog-title">
                    <DialogTitle id="customized-dialog-title" >
                        <Row>
                            <Col lg={11}>
                                Update {dateToEdit === "ongoing_cycle_complete_datetime"
                                ? "Ongoing Cycle End Date"
                            : dateToEdit === "next_cycle_datetime"
                            ? "Next Cycle Date" :
                            null}
                            </Col>
                            <Col lg={1} className={"text-right align-self-center d-print-none"}>
                                <IconButton
                                    onClick={()=>setDialogOpen(false)}
                                    className={"close"}>
                                    <CloseIcon/>
                                </IconButton>
                            </Col>
                        </Row>
                    </DialogTitle>
                    <DialogContent>
                        <Row className={"text-center"}>
                            <Col>
                                <h4>
                                    Current: {bbFormattedDateString(entitySettings
                                    && entitySettings[dateToEdit], "shortFullMonth")}
                                </h4>
                                {/*<p></p>*/}
                            </Col>
                            <Col className={"text-center"}>
                                <h4 className={"align-self-center d-inline"}>
                                    Update:&nbsp;
                                </h4>
                                    <input className={"align-self-center d-inline"}
                                        type={"date"}
                                                   min={new Date(Date.now()).toDateString()}
                                                   id={dateToEdit}
                                                    name={dateToEdit}
                                                   value={selectedDate}
                                                    onChange={(e)=>setSelectedDate(e.target.value)}/>

                            </Col>
                        </Row>
                    </DialogContent>
                        <DialogActions>
                            <Col lg={12}>

                                <Button onClick={()=>setDialogOpen(false)}
                                        variant="contained" color="primary"
                                        style={{float: "right"}}>
                                    Cancel
                                </Button>
                                {selectedDate ? <Button
                                    className={"float-right"}
                                    variant="contained" color="primary"
                                    type={"submit"}
                                    onClick={()=>handleSubmit()}
                                >
                                    Submit
                                </Button>
                                : null}
                            </Col>
                        </DialogActions>



                </Dialog>}
        </span>
    )
}

export default UpdateEntityCycleDatesDialog;